import { defineStore } from "pinia";
import { useAuthStore } from "@/stores/auth";

export const residents = [
  {
    id: 1,
    residentCode: "RES-001",
    name: "สมชาย ใจดี",
    residentType: "owner",
    unitCode: "A-101",
    houseNo: "88/101",
    building: "อาคาร A",
    zone: "โซนหน้า",
    phone: "081-234-5678",
    email: "somchai@example.com",
    address: "88/101 อาคาร A โครงการ Central Fee Residence",
    emergencyContact: "สุภาวดี ใจดี",
    emergencyPhone: "089-900-1122",
    paymentStatus: "paid",
    outstanding: 0,
    occupancyStatus: "active",
    moveInDate: "2025-06-15",
    lastPaymentDate: "2026-03-29",
    note: "ชำระตรงเวลาอย่างสม่ำเสมอ",
  },
  {
    id: 2,
    residentCode: "RES-002",
    name: "สุดา รุ่งเรือง",
    residentType: "owner",
    unitCode: "A-102",
    houseNo: "88/102",
    building: "อาคาร A",
    zone: "โซนหน้า",
    phone: "082-345-6789",
    email: "suda@example.com",
    address: "88/102 อาคาร A โครงการ Central Fee Residence",
    emergencyContact: "วรัญญา รุ่งเรือง",
    emergencyPhone: "084-222-1188",
    paymentStatus: "partial",
    outstanding: 900,
    occupancyStatus: "active",
    moveInDate: "2025-09-01",
    lastPaymentDate: "2026-03-18",
    note: "มีคำขอผ่อนชำระบางส่วน",
  },
  {
    id: 3,
    residentCode: "RES-003",
    name: "นที วรากร",
    residentType: "tenant",
    unitCode: "B-203",
    houseNo: "88/203",
    building: "อาคาร B",
    zone: "โซนกลาง",
    phone: "089-111-2233",
    email: "natee@example.com",
    address: "88/203 อาคาร B โครงการ Central Fee Residence",
    emergencyContact: "ภัทรียา วรากร",
    emergencyPhone: "080-400-5000",
    paymentStatus: "overdue",
    outstanding: 3200,
    occupancyStatus: "active",
    moveInDate: "2024-11-20",
    lastPaymentDate: "2026-02-05",
    note: "ติดตามค้างชำระแล้ว 1 ครั้ง",
  },
  {
    id: 4,
    residentCode: "RES-004",
    name: "อรทัย พงศ์พันธ์",
    residentType: "owner",
    unitCode: "C-305",
    houseNo: "88/305",
    building: "อาคาร C",
    zone: "โซนสวน",
    phone: "081-778-9900",
    email: "ornthai@example.com",
    address: "88/305 อาคาร C โครงการ Central Fee Residence",
    emergencyContact: "ชาญชัย พงศ์พันธ์",
    emergencyPhone: "085-444-9911",
    paymentStatus: "paid",
    outstanding: 0,
    occupancyStatus: "active",
    moveInDate: "2025-02-10",
    lastPaymentDate: "2026-03-27",
    note: "ต้องการรับเอกสารทางอีเมล",
  },
  {
    id: 5,
    residentCode: "RES-005",
    name: "ปกรณ์ ศิริชัย",
    residentType: "owner",
    unitCode: "D-110",
    houseNo: "88/110",
    building: "อาคาร D",
    zone: "โซนหน้า",
    phone: "086-998-0011",
    email: "pakorn@example.com",
    address: "88/110 อาคาร D โครงการ Central Fee Residence",
    emergencyContact: "จิราภรณ์ ศิริชัย",
    emergencyPhone: "086-998-0022",
    paymentStatus: "paid",
    outstanding: 0,
    occupancyStatus: "active",
    moveInDate: "2023-08-18",
    lastPaymentDate: "2026-03-30",
    note: "บ้านเดี่ยว มุมถนนหลัก",
  },
];

export const invoiceHistory = {
  1: [
    {
      id: "INV-R-2026-0001",
      billingMonth: "มีนาคม 2026",
      amount: 1800,
      dueDate: "2026-03-31",
      status: "paid",
    },
    {
      id: "INV-R-2026-0031",
      billingMonth: "เมษายน 2026",
      amount: 1800,
      dueDate: "2026-04-30",
      status: "pending",
    },
  ],
  2: [
    {
      id: "INV-R-2026-0002",
      billingMonth: "มีนาคม 2026",
      amount: 1800,
      dueDate: "2026-03-31",
      status: "partial",
    },
    {
      id: "INV-R-2026-0032",
      billingMonth: "เมษายน 2026",
      amount: 1800,
      dueDate: "2026-04-30",
      status: "pending",
    },
  ],
  3: [
    {
      id: "INV-R-2026-0003",
      billingMonth: "กุมภาพันธ์ 2026",
      amount: 2500,
      dueDate: "2026-02-28",
      status: "overdue",
    },
    {
      id: "INV-R-2026-0016",
      billingMonth: "มีนาคม 2026",
      amount: 2500,
      dueDate: "2026-03-31",
      status: "overdue",
    },
    {
      id: "INV-R-2026-0033",
      billingMonth: "เมษายน 2026",
      amount: 2500,
      dueDate: "2026-04-30",
      status: "pending",
    },
  ],
};

export const paymentHistory = {
  1: [
    {
      id: "PAY-R-2026-0011",
      date: "2026-03-29",
      amount: 1800,
      method: "โอนธนาคาร",
      receiptNo: "RC-R-2026-0011",
    },
    {
      id: "PAY-R-2026-0004",
      date: "2026-02-27",
      amount: 1800,
      method: "QR Payment",
      receiptNo: "RC-R-2026-0004",
    },
  ],
  2: [
    {
      id: "PAY-R-2026-0014",
      date: "2026-03-18",
      amount: 900,
      method: "เงินสด",
      receiptNo: "RC-R-2026-0014",
    },
  ],
  3: [
    {
      id: "PAY-R-2026-0001",
      date: "2026-02-05",
      amount: 1800,
      method: "โอนธนาคาร",
      receiptNo: "RC-R-2026-0001",
    },
  ],
};

export const useResidentStore = defineStore("resident", {
  state: () => ({
    filters: {
      search: "",
      residentType: "",
      paymentStatus: "",
    },
    residents,
    invoiceHistory,
    paymentHistory,
  }),

  getters: {
    filteredResidents: (state) => {
      const keyword = state.filters.search.trim().toLowerCase();

      return state.residents.filter((resident) => {
        const searchable = [
          resident.residentCode,
          resident.name,
          resident.unitCode,
          resident.houseNo,
          resident.building,
          resident.phone,
          resident.email,
        ]
          .join(" ")
          .toLowerCase();

        const matchesSearch = !keyword || searchable.includes(keyword);
        const matchesType =
          !state.filters.residentType ||
          resident.residentType === state.filters.residentType;
        const matchesPaymentStatus =
          !state.filters.paymentStatus ||
          resident.paymentStatus === state.filters.paymentStatus;

        return matchesSearch && matchesType && matchesPaymentStatus;
      });
    },

    totalResidents: (state) => state.residents.length,
    ownerCount: (state) =>
      state.residents.filter((item) => item.residentType === "owner").length,
    tenantCount: (state) =>
      state.residents.filter((item) => item.residentType === "tenant").length,
    overdueCount: (state) =>
      state.residents.filter((item) => item.paymentStatus === "overdue").length,
    totalOutstanding: (state) =>
      state.residents.reduce((sum, item) => sum + item.outstanding, 0),

    residentTypeOptions: () => [
      { label: "ทั้งหมด", value: "" },
      { label: "เจ้าของ", value: "owner" },
      { label: "ผู้เช่า", value: "tenant" },
    ],

    paymentStatusOptions: () => [
      { label: "ทั้งหมด", value: "" },
      { label: "ชำระแล้ว", value: "paid" },
      { label: "ชำระบางส่วน", value: "partial" },
      { label: "ค้างชำระ", value: "overdue" },
    ],

    getResidentById: (state) => (id) =>
      state.residents.find((item) => item.id === Number(id)) || null,
    getInvoicesByResidentId: (state) => (id) =>
      state.invoiceHistory[Number(id)] || [],
    getPaymentsByResidentId: (state) => (id) =>
      state.paymentHistory[Number(id)] || [],
  },

  actions: {
    setSearch(value) {
      this.filters.search = value;
    },
    setResidentType(value) {
      this.filters.residentType = value;
    },
    setPaymentStatus(value) {
      this.filters.paymentStatus = value;
    },
    resetFilters() {
      this.filters.search = "";
      this.filters.residentType = "";
      this.filters.paymentStatus = "";
    },
    addResident(payload) {
      const nextId =
        this.residents.length > 0
          ? Math.max(...this.residents.map((r) => r.id)) + 1
          : 1;

      const residentCode = `RES-${String(nextId).padStart(3, "0")}`;

      this.residents.push({
        id: nextId,
        residentCode,
        paymentStatus: "paid",
        outstanding: 0,
        lastPaymentDate: null,
        ...payload,
      });

      const auth = useAuthStore();
      auth.syncResidentUsers(this.residents);
    },
    updateResident(payload) {
      const index = this.residents.findIndex(
        (item) => item.id === Number(payload.id),
      );

      if (index !== -1) {
        this.residents[index] = {
          ...this.residents[index],
          ...payload,
        };
      }
    },
  },
});
